<img *ngIf="image" [src]="image" />
<ng-content *ngIf="!image"></ng-content>
<ion-text *ngIf="title">
  <h2 class="no-data__title">{{ title }}</h2>
</ion-text>
<ion-text *ngIf="message" class="no-data__subtitle">
  {{ message }}
</ion-text>
